import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { addAccount } from '../actions/accountActions';

const OpenPage: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState('CHECKING');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userLogin = useSelector((state: appState) => state.userLogin);
  const { userData } = userLogin;

  useEffect(() => {
    if (!userData) {
      navigate('/signup');
      return;
    }
  }, [navigate, userData]);

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();

    const num = Math.floor(Math.random() * 10000000000);
    const accountNum = num.toString();

    dispatch(addAccount(accountNum, selectedOption));
  };

  const accountsList = useSelector((state: appState) => state.accountsList);
  const { error, success } = accountsList;

  return (
    <div className='account-page'>
      <Navigation />
      <form className='open-form' onSubmit={submitHandler}>
        <p>What type of account would you like to open?</p>
        <div className='select-account'>
          <div className='select-input'>
            <input
              type='radio'
              id='checking'
              name='account'
              value='CHECKING'
              checked={selectedOption === 'CHECKING'}
              onChange={(e) => setSelectedOption(e.target.value)}
            />
            <label htmlFor='checking'>Checking Account</label>
          </div>
          <div className='select-input'>
            <input
              type='radio'
              id='savings'
              name='account'
              value='SAVINGS'
              checked={selectedOption === 'SAVINGS'}
              onChange={(e) => setSelectedOption(e.target.value)}
            />
            <label htmlFor='savings'>Savings Account</label>
          </div>
        </div>
        <button type='submit' className='open-btn'>
          Open Account
        </button>
        {success && (
          <p className='success'>
            Account added successfully! Go to the{' '}
            <Link to='/account'>account summary page</Link> to view your
            balances.
          </p>
        )}
        {error && <p className='fail'>{error}</p>}
      </form>
    </div>
  );
};

export default OpenPage;
